import { axios } from '@tencent/pmd-network/lib/request/web/axios';
import { post } from '@tencent/pmd-network';
import { Toast } from '@tencent/pmd-widget/lib/toast';
import { initEnv, isTestEnv } from '@tencent/pmd-tools/lib/env';
import { getPvpPartition } from '@tencent/pmd-tools/lib/url';
import { showComponentDialog } from '@tencent/pmd-tools/lib/dialog-displayer';
import { GAME_PVP, GAME_LOLM, GAME_GP, GAME_MAJIANG, GAME_HLDDZ } from '@tencent/pmd-tools/lib/game';
import { GoodsConfigInfo } from '@tencent/pmd-config/lib/goods';
import { getAppMainRole, getCurrentRole } from './role-@TIP_PLATFORM_NAME';
import { getConfig } from '@tencent/pmd-config';

const requestHost = () => (window.location.origin.indexOf('test') !== -1 && window.sessionStorage.getItem('tip_debug_cgi_env') != 'prod' ? 'https://api-test.igame.qq.com' : 'https://api.igame.qq.com');

/**
 * 获取角色列表
 */
const getRoleList = function () {
  return new Promise((resolve, reject) => {
    post({
      url: GoodsConfigInfo.instance.queryRoleListUrl || '/pvp/comm/user/get_role_list',
      oldCGI: true,
      reqData: {
        gid: app.tip_gid || getConfig('game.gid'),
      },
    })
      .then((response) => {
        const roleList = [];
        if (response.role_info && response.role_info.RoleList) {
          for (let i = 0; i < response.role_info.RoleList.length; i++) {
            roleList.push(response.role_info.RoleList[i].role_base_info);
          }
        }
        console.log(roleList);
        resolve(roleList);
      })
      .catch((error) => {
        console.log(error);
        if (error.r === 19) {
          resolve([]);
        } else {
          Toast.showFail(error.msg);
          reject(error);
        }
      });
  });
};


const getLolmRole = function () {
  return new Promise((resolve, reject) => {
    post({
      url: '/pmdtrpc.commcgi.tipcgi.tipcgi/QuerySLolRoleList',
      reqData: {
        device: initEnv().isIOS ? 1 : 2,
      },
      showMsgToast: false,
    })
      .then((response) => {
        let mainRole = {};
        if (response.rolelist && response.rolelist.length > 0) {
          const plat = initEnv().isIos ? 1 : (initEnv().isAndroid ? 2 : 0);
          for (let i = 0; i < response.rolelist.length; i++) {
            const role = response.rolelist[i];
            if (plat === role.device) {
              mainRole = role;
              break;
            }
          }
        }

        resolve(mainRole);
      })
      .catch((error) => {
        console.log(error);
        if (error.r === 19) {
          resolve({});
        } else {
          reject(error);
        }
      });
  });
};

const getMainRole = function () {
  const env = initEnv();
  return new Promise((resolve, reject) => {
    const storageRole = window.sessionStorage.getItem('pvp_role');
    if (storageRole) {
      resolve(JSON.parse(storageRole));
      return;
    }
    if (env.isInGame || env.isGHelper) { // 游戏内获取与大区号匹配的角色，匹配不到就是最近登录角色
      console.log('获取游戏内角色……');
      const subarea = getPvpPartition();
      getRoleInfo(subarea)
        .then((selectRole) => {
          console.log('获取游戏内角色:', selectRole);
          window.sessionStorage.setItem('pvp_role', JSON.stringify(selectRole));
          resolve(selectRole);
        })
        .catch(() => {
          console.log('getMainRole 查询不到角色');
          reject({ r: 1, msg: '没有角色' });
        });
    } else { // 获取app主角色
      getAppMainRole()
        .then((role) => {
          console.log('获取App角色……');
          console.log('获取App角色:', role);
          if (role) {
            window.sessionStorage.setItem('pvp_role', JSON.stringify(role));
            resolve(role);
          } else {
            console.log('getMainRole 接口查询不到角色');
            reject();
          }
        })
        .catch(() => {
          console.log('getMainRole 查询不到角色');
          reject({ r: 1, msg: '没有角色' });
        });
    }
  });
};

const getGameCurrentRole = function () {
  // 按游戏缓存角色信息
  const gid = Number(app.tip_gid || getConfig('game.gid'));
  const roleCacheKey = `${gid}_tip_role`;
  return new Promise((resolve, reject) => {
    let tipRole = null;
    if (app.tip_role?.roleidx) {
      tipRole = {
        role_base_info: app.tip_role,
      };
    } else {
      tipRole = window.sessionStorage.getItem(roleCacheKey);
      if (tipRole) {
        tipRole = JSON.parse(tipRole);
      }
    }

    if (tipRole && tipRole.role_base_info && tipRole.role_base_info.roleidx) {
      resolve(tipRole);
    } else {
      let getMainRoleFunc;
      if (gid === GAME_PVP) {
        getMainRoleFunc = getMainRole;
      } else if ((gid === GAME_GP && !initEnv().isGHelper20004) || gid === GAME_HLDDZ || gid === GAME_MAJIANG) {
        getMainRoleFunc = getCurrentRole;
      } else if (gid === GAME_LOLM) {
        getMainRoleFunc = getLolmRole;
      } else {
        getMainRoleFunc = getIGameRoleInfo.bind(null, undefined, undefined, false);
      }
      // 后续物品详情改造中需要去掉，查询角色强制使用QueryRoleList接口
      if (GoodsConfigInfo.instance.forceUseQueryRoleList) {
        getMainRoleFunc = getIGameRoleInfo;
      }
      getMainRoleFunc()
        .then((role) => {
          let retRole = {};
          if (!role.role_base_info) {
            if (role.roleInfo) {
              retRole = { role_base_info: role.roleInfo };
            } else {
              retRole = { role_base_info: role };
            }
          } else {
            retRole = role;
          }
          window.sessionStorage.setItem(roleCacheKey, JSON.stringify(retRole));
          resolve(retRole);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    }
  });
};

const getSubArea = function () {
  const env = initEnv();
  return new Promise((resolve, reject) => {
    // 特殊处理下游戏内和王者营地的逻辑
    if (env.isInGame || env.isGHelper) {
      console.log('获取游戏内角色……');
      const subArea = getPvpPartition();
      console.log('获取游戏内角色:', subArea);
      resolve(subArea);
      return;
    }
    console.log('获取App角色……');
    getAppMainRole()
      .then((role) => {
        console.log('获取App角色:', role);
        if (role && role.role_base_info && role.role_base_info.subarea) {
          resolve(role.role_base_info.subarea);
        } else {
          reject();
        }
      })
      .catch(() => {
        reject();
      });
  });
};

// 根据subArea获取角色信息
const getRoleInfo = function (subArea = 0) {
  return new Promise((resolve, reject) => {
    const reqData = {
      need_grade: 1,
    };
    post({
      reqData,
      oldCGI: true,
      showMsgToast: false,
      url: GoodsConfigInfo.instance.queryRoleListUrl || '/pvp/comm/user/get_role_list',
    })
      .then((response) => {
        if (response.role_info) {
          const tempRoleList = response.role_info.RoleList;
          const { gopenid } = response;

          const laderList = response.lader_info || [];

          // 处理gopenid
          for (let i = 0; i < tempRoleList.length; i++) {
            tempRoleList[i].role_base_info.gopenid = gopenid || '';
            for (let j = 0; j < laderList.length; j++) {
              if (tempRoleList[i].role_base_info.subarea == laderList[j].subarea) {
                tempRoleList[i].role_base_info.lader_text = laderList[j].lader_text;
                tempRoleList[i].role_base_info.lader = laderList[j].lader;
                tempRoleList[i].role_base_info.lader_score = laderList[j].lader_score;
                break;
              }
            }
          }

          let selectRole = tempRoleList[0];
          if (subArea != 0) {
            for (let i = 0; i < tempRoleList.length; i++) {
              if (subArea == tempRoleList[i].role_base_info.subarea) {
                selectRole = tempRoleList[i];
                break;
              }
            }
          }

          resolve(selectRole);
        } else {
          console.log('查询不到角色');
          reject();
        }
      })
      .catch((error) => {
        if (error.r != 100000) {
          console.log('查询不到角色');
          reject();
        }
      });
  });
};

// 获取lol大区列表
const getLolSubAreaList = function () {
  return new Promise((resolve, reject) => {
    const url = 'https://image-1251917893.cos.ap-guangzhou.myqcloud.com/igame/merchant/lol/lol-area-list.txt';
    const env = initEnv();
    if (env.isMPWeixin || env.isMPQQ) {
      uni.request({
        url,
        method: 'GET',
        success: (res) => {
          resolve(parserLolAreaList(res.data));
        },
        fail: (error) => {
          reject(error);
        },
      });
    } else {
      axios.get(url)
        .then((response) => {
          resolve(parserLolAreaList(response.data));
        })
        .catch((error) => {
          reject(error);
        });
    }
  });
};

const parserLolAreaList = function (servers) {
  const subAreaList = [];
  for (let i = 0; i < servers.length; i++) {
    if (servers[i].status == 1) {
      const server = {
        subarea: parseInt(servers[i].v),
        subareaName: servers[i].t,
      };
      subAreaList.push(server);
    }
  }
  return subAreaList;
};

// 获取lol角色
const getLolRoleInfo = function (subArea = 0) {
  return new Promise((resolve, reject) => {
    const reqData = {
      gid: 26, // lol端游id
      uType: 1, // 1 QQ 2 微信
      subArea,
    };
    const LGameApiHostTEST = 'https://api-test.nes.slol.qq.com';
    const LGameApiHost = 'https://api.nes.slol.qq.com';
    const url = `${isTestEnv() ? LGameApiHostTEST : LGameApiHost}/slolnes.cgi.rift.rift/GetRoleList`;
    post({
      reqData,
      oldCGI: true,
      showMsgToast: false,
      url,
    })
      .then((response) => {
        if (response.role) {
          resolve(response.role);
        }
      })
      .catch(() => {
        Toast.showFail('查询不到角色');
        reject();
      });
  });
};

/**
 * 更新头像协议为 https
 */
function updateHeadHttpUrl(url) {
  return url?.replace?.('http://', 'https://') ?? url;
}

/**
 * 获取角色列表
 */
const getIGameRoleInfo = function (gid = 0, subarea = 0, showMsgToast = true) {
  const env = initEnv();
  return new Promise((resolve, reject) => {
    const plat = env.isIOS ? 1 : (env.isAndroid ? 2 : 0);
    const gameGid = gid === 0 ? (app.tip_gid || getConfig('game.gid')) : gid;
    post({
      url: GoodsConfigInfo.instance.queryRoleListUrl
        || '/pmdtrpc.commcgi.tipcgi.tipcgi/QueryRoleList',
      reqData: {
        gid: gameGid,
        device: plat,
        subarea,
      },
      showMsgToast,
    })
      .then((response) => {
        const info = { roleList: [] };
        if (response.rolelist) {
          for (let i = 0; i < response.rolelist.length; i++) {
            info.roleList.push({ ...response.rolelist[i], rolehead: updateHeadHttpUrl(response.rolelist[i].rolehead) });
          }
        }
        if (response.role) {
          info.roleInfo = { ...response.role, rolehead: updateHeadHttpUrl(response.role.rolehead) };
        }

        resolve(info);
      })
      .catch((error) => {
        console.log('[error]getIGameRoleInfo', error);
        const noRoleErrMap = {
          [GAME_PVP]: 19, // 无王者游戏角色时的错误码
          [GAME_GP]: 404, // 无和平游戏角色时的错误码
          [GAME_MAJIANG]: 404, // 无麻将游戏角色时的错误码
          [GAME_HLDDZ]: 404, // 无斗地主游戏角色时的错误码
        };
        const noRoleErr = noRoleErrMap[gameGid] || 25227404; // 25227404=其他游戏统一的错误码
        if (error.r === noRoleErr) {
          resolve({});
          return;
        }

        if (error.r === 100000) { // 未登录
          reject(error);
          return;
        }

        // 其余错误
        // Toast.showFail(error.msg);
        reject(error);
      });
  });
};

/**
 * @description 弹出游戏角色选择弹窗
 * @export
 * @param {object} [roleInfo={}] 可选，设置默认选中角色，若为空对象，则自动读取后台下发的游戏主角色
 * @param {object} [autoCloseOnChange=true] 可选，默认选中后自动关闭选择弹窗
 * @param {function} [onChange] 用户切换选择回调，回调函数参数为用户所选角色；
 * @param {function} [onClose] 用户关闭弹窗回调
 * @returns {Promise<compIntance>}
 * @example
 * const params = {
 *  roleInfo: {},
 *  autoCloseOnChange: false,
 *  onChang: (role) => {
 *   console.log('切换角色', role);
 *  },
 *  onClose: (role) => {
 *   console.log('最终选择的角色', role);
 *  }
 * }
 * const vueInstance =  this || window.app || new Vue();
 * showRoleSelectDialog(vueInstance, params);
 */
function showRoleSelectDialog(vueInstance, params = {}) {
  const {
    roleInfo = {},
    autoCloseOnChange = true,
    onChange = null,
    onClose = null,
    gid = 331,
    title = '',
    desc = '',
  } = params;

  const dialogProps = {
    gid,
    show: true,
    isShowByFunction: true,
    value: roleInfo,
    title,
    desc,
  };

  const dialogComp = () => import('src/component/module/tip-comm/igame-role-select');
  return new Promise((resolve, reject) => {
    showComponentDialog(vueInstance, dialogComp, dialogProps)
      .then((comp) => {
        comp.$on('changeRole', (role) => {
          comp.$set(comp.$props, 'value', role);
          onChange?.(role);

          // 自动关闭
          if (autoCloseOnChange) {
            comp.closeDialog();
          }
        });
        comp.$on('close', (role) => {
          onClose?.(role);
        });

        resolve(comp);
      })
      .catch((err) => {
        console.error('[error]showRoleSelectDialog', err);
        reject(err);
      });
  });
}

/**
 * 检查当前账号是否绑定了明文的QQ号（端游需要通过QQ号发奖）
 *
 * @return {Promise<unknown>}
 */
const getPCGameBindQQStatus = function () {
  return new Promise((resolve, reject) => {
    post({
      url: `${requestHost()}/pc_esports.cgi_esports.role.role/CheckQQTransResult`,
      reqData: {},
      showMsgToast: false,
    })
      .then((response) => {
        console.log(response);
        resolve(response);
      })
      .catch((error) => {
        console.log('[error]checkBindQQStatus', error);
        reject(error);
      });
  });
};

/**
 * 端游获取大区列表
 *
 * @param gid
 * @return {Promise<unknown>}
 */
const getPCGameAreaList = function (gid) {
  return new Promise((resolve, reject) => {
    post({
      url: `${requestHost()}/pc_esports.cgi_esports.role.role/QueryGameAllArea`,
      reqData: { gid },
      showMsgToast: false,
    })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.log(error);
        if (error.r === 19) {
          resolve({});
        } else {
          reject(error);
        }
      });
  });
};

export default {
  getRoleList,
  getCurrentRole,
  getGameCurrentRole,
  getAppMainRole,
  getMainRole,
  getSubArea,
  getRoleInfo,
  getLolmRole,
  getLolSubAreaList,
  getLolRoleInfo,
  getIGameRoleInfo,
  showRoleSelectDialog,
  getPCGameBindQQStatus,
  getPCGameAreaList,
};

export {
  getRoleList,
  getCurrentRole,
  getGameCurrentRole,
  getAppMainRole,
  getMainRole,
  getSubArea,
  getRoleInfo,
  getLolmRole,
  getLolSubAreaList,
  getLolRoleInfo,
  getIGameRoleInfo,
  showRoleSelectDialog,
  getPCGameBindQQStatus,
  getPCGameAreaList,
};
